module.exports = __webpack_public_path__ + "static/assets/fefb7e2fcd4d311a5a7c3de5a8ae5b64.mp3";